// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 234 ? "3f0975f1" : chunkId) + "." + {"234":"49e128e9e3f24753","425":"abe104a42b59f066","916":"f9383b5fbf55e196","8278":"e3e6a690fc0cf84b","8493":"cda064869d304c7d","8719":"09d8efac71b00bb5","8822":"de993d2f9a0c870f"}[chunkId] + ".js";
};